import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export const LogInRoutes = ({
  path: 'login',
  getData: ({ context: { props } }) => props || {},
  async getComponent (nextState) {
    const {
      default: AuthenticationContainer
    } = await import(/* webpackChunkName: "login" */ './AuthenticationContainer')
      .catch(handleChunkLoadError);
    return AuthenticationContainer;
  },
  children: [
    {
      path: '',
      async getComponent () {
        const {
          default: SigninPage
        } = await import(/* webpackChunkName: "sign-in" */ './routes/signin/components/SigninPage')
          .catch(handleChunkLoadError);
        return SigninPage;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'forgot',
      async getComponent () {
        const {
          default: ForgotPasswordPage
        } = await import(/* webpackChunkName: "forgot-password" */ './routes/forgot-password/components/ForgotPasswordPage')
          .catch(handleChunkLoadError);
        return ForgotPasswordPage;
      },
      getData: ({ context: { props } }) => props || {}
    }
  ]
});

export const SignupRoutes = ({
  path: 'signup',
  async getComponent (nextState) {
    const {
      default: AuthenticationContainer
    } = await import(/* webpackChunkName: "signup" */ './AuthenticationContainer')
      .catch(handleChunkLoadError);
    return AuthenticationContainer;
  },
  children: [
    {
      path: '',
      async getComponent () {
        const {
          default: RegisterPage
        } = await import(/* webpackChunkName: "signup" */ './routes/register/components/RegisterPage')
          .catch(handleChunkLoadError);
        return RegisterPage;
      },
      getData: ({ context: { props } }) => props || {}
    }
  ]
});

export default ({
  path: 'authentication',
  async getComponent (nextState) {
    const {
      default: AuthenticationContainer
    } = await import(/* webpackChunkName: "authentication" */ './AuthenticationContainer')
      .catch(handleChunkLoadError);
    return AuthenticationContainer;
  },
  children: [
    {
      path: 'sign-in',
      async getComponent () {
        const {
          default: LoginPage
        } = await import(/* webpackChunkName: "sign-in" */ './routes/signin/components/SigninPage')
          .catch(handleChunkLoadError);
        return LoginPage;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'register',
      async getComponent () {
        const {
          default: SignupPage
        } = await import(/* webpackChunkName: "register" */ './routes/register/components/RegisterPage')
          .catch(handleChunkLoadError);
        return SignupPage;
      },
      getData: ({ context: { props } }) => props || {}
    },
    {
      path: 'reset-password/:regenerationKey',
      async getComponent () {
        const {
          default: ResetPasswordPage
        } = await import(/* webpackChunkName: "reset-password" */ './routes/reset-password/components/ResetPasswordPage')
          .catch(handleChunkLoadError);
        return ResetPasswordPage;
      },
      getData: ({ context: { props } }) => props || {}
    }
  ]
});
